import React from "react"
import BlogMain from "./BlogMain"

export default function index() {
    return (
        <>
            <BlogMain />
        </>
    )
}
